import React from "react";
import useInteresadosLogic from "./hooks/useInteresadosLogic";
import InteresadosView from "./pages/InteresadosView.jsx";

export default function Interesados() {
  const logic = useInteresadosLogic();
  return <InteresadosView {...logic} />;
}
